import { createStore } from 'vuex';
export default createStore({
  state:{
    loading: false,
    microApp: JSON.parse(sessionStorage.getItem('micro'))?.microApp || 'iframe',
    microLink: JSON.parse(sessionStorage.getItem('micro'))?.microLink || '/vcommon/home?hideMenu=1'
  },
  mutations:{
    setLoading(state, data) {
      state.loading = data
    },
    changeMicro(state, data){
      state.microApp = data.microApp;
      state.microLink = data.microLink;
      sessionStorage.setItem('micro',JSON.stringify(data))
    }
  }
})